import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import styles from './Text.styles.module.scss';

interface ITypographyProps {
  type?: 'titleMedium';
  className?: string;
  children: string;
  tooltip?: string;
}

export const Text = ({ type, className, children, tooltip }: ITypographyProps) => {
  const { i18n } = useTranslation();

  return (
    <span
      title={tooltip && i18n.t(tooltip as KeyMapKeys)}
      className={cn(className, {
        [styles.titleMedium]: type === 'titleMedium',
      })}>
      {i18n.t(children as KeyMapKeys)}
    </span>
  );
};
